import { Container, Row } from "reactstrap";
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs";
import { Crypto, Dashboard } from "../../../utils/Constant";
import TotalEarning from "./TotalEarning/TotalEarning";
import ActiveOrder from "./ActiveOrder/ActiveOrder";
import BuySellSection from "./BuySellSection/BuySellSection";
import LivePrices from "./LivePrices/LivePrices";
import RecentTradingActivities from "./RecentTradingActivities/RecentTradingActivities";
import MarketOverview from "./MarketOverview/MarketOverview";
import ContactDetails from "./ContactDetails/ContactDetails";
import OurContributed from "./OurContributed/OurContributed";
import Balance from "./Balance/Balance";
import LiveMarketCap from "./LiveMarketCap/LiveMarketCap";
import PopularCoins from "./PopularCoins/PopularCoins";

const ContainerCrypto = () => {
  return (
    <>
      <Breadcrumbs mainTitle={Crypto} parent={Dashboard} />
      <Container fluid className="dashboard_default">
        <Row className="widget-grid">
          <TotalEarning />
          <ActiveOrder />
          <BuySellSection />
          <LivePrices />
          <RecentTradingActivities />
          <MarketOverview />
          <ContactDetails />
          <OurContributed />
          <Balance />
          <LiveMarketCap />
          <PopularCoins />
        </Row>
      </Container>
    </>
  );
};

export default ContainerCrypto;
